import { createService } from '@bonanza-social/toolkit/api';
import {
  PrizeWallSchema,
  PrizeWallCampaignSchema,
  PrizeWallRewardSchema,
  PrizeWallWinnersSchema,
} from './PrizeWallCampaignService.schemas';
// import { MockedCampaign } from '../../state/prizeWallCampaign/prizeWallCampaign.mocks';
// import { MockedWall } from '../../state/prizeWall/prizeWall.mocks';
// import { MockedWinners } from '../../state/prizeWallWinners/prizeWallWinners.mocks';

export default {
  ...createService(
    {
      getCampaign: {
        method: 'GET',
        url: '/tokencampaigns/active',
        responseSchema: PrizeWallCampaignSchema,
        // getMock: async () => {
        //   await new Promise((resolve) => {
        //     setTimeout(resolve, 1000);
        //   });

        //   return MockedCampaign;
        // },
      },
      getWall: {
        method: 'GET',
        url: ({ campaignId }: { campaignId: number }) =>
          `/tokencampaigns/${campaignId}/walls/active`,
        responseSchema: PrizeWallSchema,
        // getMock: async () => {
        //   await new Promise((resolve) => {
        //     setTimeout(resolve, 1000);
        //   });

        //   return MockedWall;
        // },
      },
      getWallReward: {
        method: 'POST',
        url: ({ campaignId, wallId }: { campaignId: number; wallId: number }) =>
          `/tokencampaigns/${campaignId}/walls/${wallId}/play`,
        responseSchema: PrizeWallRewardSchema,
        // getMock: async () => {
        //   await new Promise((resolve) => {
        //     setTimeout(resolve, 500);
        //   });

        //   return {
        //     isWin: false,
        //     rewardId: '1',
        //     tokenBalance: 50,
        //   };
        // },
      },
    },
    ({ userId }) => `/Players/${userId}`,
  ),
  ...createService({
    getWallWinners: {
      method: 'GET',
      url: ({ campaignId, wallId }: { campaignId: number; wallId: number }) =>
        `/tokencampaigns/${campaignId}/walls/${wallId}/winners`,
      responseSchema: PrizeWallWinnersSchema,
      // getMock: async () => {
      //   await new Promise((resolve) => {
      //     setTimeout(resolve, 500);
      //   });

      //   return MockedWinners;
      // },
    },
  }),
};
